/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
import type { PlatformSubsidiary } from './';
import {
    PlatformSubsidiaryFromJSON,
    PlatformSubsidiaryFromJSONTyped,
    PlatformSubsidiaryToJSON,
} from './';

/**
 * 
 * @export
 * @interface PlatformSubsidiariesResource
 */
export interface PlatformSubsidiariesResource {
    /**
     * 
     * @type {Array<PlatformSubsidiary>}
     * @memberof PlatformSubsidiariesResource
     */
    subsidiaries?: Array<PlatformSubsidiary>;
}

/**
 * Check if a given object implements the PlatformSubsidiariesResource interface.
 */
export function instanceOfPlatformSubsidiariesResource(value: object): value is PlatformSubsidiariesResource {
    return true;
}

export function PlatformSubsidiariesResourceFromJSON(json: any): PlatformSubsidiariesResource {
    return PlatformSubsidiariesResourceFromJSONTyped(json, false);
}

export function PlatformSubsidiariesResourceFromJSONTyped(json: any, ignoreDiscriminator: boolean): PlatformSubsidiariesResource {
    if (json == null) {
        return json;
    }
    return {
        
        'subsidiaries': json['subsidiaries'] == null ? undefined : ((json['subsidiaries'] as Array<any>).map(PlatformSubsidiaryFromJSON)),
    };
}

export function PlatformSubsidiariesResourceToJSON(value?: PlatformSubsidiariesResource | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'subsidiaries': value['subsidiaries'] == null ? undefined : ((value['subsidiaries'] as Array<any>).map((v) => PlatformSubsidiaryToJSON(v))),
    };
}

